// `reduceTuple` provides a work-around for a javascript short-coming of
// slow pattern-matching/destructuring,
// ```
// [gr, nd, obj] = tuple // slow
// ```
//
// Cumbersome index lookups give reasonable performance,
// ```
// gr = tuple[0] // not-slow, yet cumbersome
// nd = tuple[1]
// obj = tuple[2]
// ```
//
// This reducer expands a 3-item tuple `[one, two, three]` as the first three
// arguemnts passed to the reducer function. This way, the reducer can expect
// to use tuple values directly, w/out lookup or slowness
const gnarrReduceTuple = async (arr, fn, acctuplestart) => {
  if (arr.length === 0)
    return acctuplestart

  return (async function next (x, arr, len, acctuple) {
    if (x >= len) return acctuple

    acctuple = await fn(acctuple[0], acctuple[1], acctuple[2], arr[x], x)

    return next(++x, arr, len, acctuple)
  }(0, arr, arr.length, acctuplestart))
}

const gnarrReduce = async (arr, fn, acc, i=0) => {
  if (arr.length === 0)
    return acc

  return gnarrReduce(arr.slice(1), fn, await fn(acc, arr[0], i), ++i)
}

const gnarrElemMv = (arr, idxsrc, idxdest) => {
  idxsrc = typeof idxsrc === 'number' ? idxsrc : arr.length - 1
  arr = arr.slice()
  arr.splice(idxdest, 0, arr.splice(idxsrc, 1)[0])

  return arr
}

export {
  gnarrReduceTuple,
  gnarrReduce,
  gnarrElemMv
}
